const safeJsonParse = (jsonString, { defaultValue = null } = {}) => {
  if (jsonString === null) return defaultValue;
  let parsedString;

  try {
    parsedString = JSON.parse(jsonString);
  } catch(e) {
    return defaultValue;
  }

  return parsedString;
}

export default safeJsonParse;
